import { FC, useState } from 'react'

import { Space } from '@tribeplatform/gql-client/types'
import { SpacePicker } from '@tribeplatform/react-components/EntityPicker'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { Link } from '@tribeplatform/react-ui-kit/Link'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { useUserImportContext } from './UserImportContext'

export interface SpaceMultipleAutocompleteProps {
  onChange: (values: Space[]) => void
  value: Space[]
}

export const SpaceMultipleAutocomplete: FC<
  SpaceMultipleAutocompleteProps
> = props => {
  const { $t, formatList } = useI18n()
  const { onChange, value = [] } = props
  const context = useUserImportContext()

  const [customSelect, setCustomSelect] = useState(false)

  return (
    <>
      {customSelect && (
        <SpacePicker
          onChange={onChange}
          value={value}
          placeholder={$t({
            defaultMessage: 'Search {SPACES}',
            id: 'Generics.SearchSpaces',
          })}
          multiple
        />
      )}
      {!customSelect && (
        <div className="text-sm flex space-s-2 text-content-subdued">
          {value?.length > 0 && (
            <Text>
              <T
                defaultMessage="Newly invited members will automatically join {spaces}"
                id="UserImport.AutoJoinSpaceList"
                values={{
                  spaces: formatList(
                    value.map(it => <b key={it.id}>{it.name}</b>),
                    { type: 'conjunction' },
                  ),
                }}
              />
            </Text>
          )}
          {context?.hasInviteDefaultsPermission && (
            <Link
              as="button"
              type="button"
              onClick={() => setCustomSelect(true)}
              data-testid="spaces-edit"
            >
              <T defaultMessage="Edit" id="Generics.Edit" />
            </Link>
          )}
        </div>
      )}
    </>
  )
}
